import type {
  CompanyDictionariesStatistics,
  CompanyDictionariesStatisticsData,
} from '../interfaces/statistics/company-dictionaries-statistics';
import type {
  ContractorsStatistics,
  ContractorsStatisticsData,
} from '../interfaces/statistics/contractors-statistics';
import type {
  DelegationsStatistics,
  DelegationsStatisticsData,
} from '../interfaces/statistics/delegations-statistics';
import type {
  DriverStatistics,
  DriverStatisticsData,
} from '../interfaces/statistics/drivers-statistics';
import type {
  EmployeeStatistics,
  EmployeeStatisticsData,
} from '../interfaces/statistics/employee-statistics';
import type {
  EmployeesStatistics,
  EmployeesStatisticsData,
} from '../interfaces/statistics/employees-statistics';
import type {
  FleetStatistics,
  FleetStatisticsData,
} from '../interfaces/statistics/fleet-statistics';
import type {
  OrdersStatistics,
  OrdersStatisticsData,
} from '../interfaces/statistics/orders-statistics';
import type {
  PointsOfInterestStatistics,
  PointsOfInterestStatisticsData,
} from '../interfaces/statistics/points-of-interest-statistics';
import type {
  VehicleTypeStatistics,
  VehicleTypeStatisticsData,
} from '../interfaces/statistics/vehicle-type-statistics';

export enum StatisticsType {
  COMPANY_DICTIONARIES = 'company-dictionaries',
  CONTRACTORS = 'contractors',
  DELEGATIONS = 'delegations',
  DRIVERS = 'drivers',
  EMPLOYEE = 'employee',
  EMPLOYEES = 'employees',
  FLEET = 'fleet',
  ORDERS = 'orders',
  POINTS_OF_INTEREST = 'points-of-interest',
  VEHICLE_TYPE = 'vehicle-type',
}

export interface StatisticsByType {
  [StatisticsType.COMPANY_DICTIONARIES]: CompanyDictionariesStatistics;
  [StatisticsType.CONTRACTORS]: ContractorsStatistics;
  [StatisticsType.DELEGATIONS]: DelegationsStatistics;
  [StatisticsType.DRIVERS]: DriverStatistics;
  [StatisticsType.EMPLOYEE]: EmployeeStatistics;
  [StatisticsType.EMPLOYEES]: EmployeesStatistics;
  [StatisticsType.FLEET]: FleetStatistics;
  [StatisticsType.ORDERS]: OrdersStatistics;
  [StatisticsType.POINTS_OF_INTEREST]: PointsOfInterestStatistics;
  [StatisticsType.VEHICLE_TYPE]: VehicleTypeStatistics;
}

export interface StatisticsDataByType {
  [StatisticsType.COMPANY_DICTIONARIES]: CompanyDictionariesStatisticsData;
  [StatisticsType.CONTRACTORS]: ContractorsStatisticsData;
  [StatisticsType.DELEGATIONS]: DelegationsStatisticsData;
  [StatisticsType.DRIVERS]: DriverStatisticsData;
  [StatisticsType.EMPLOYEE]: EmployeeStatisticsData;
  [StatisticsType.EMPLOYEES]: EmployeesStatisticsData;
  [StatisticsType.FLEET]: FleetStatisticsData;
  [StatisticsType.ORDERS]: OrdersStatisticsData;
  [StatisticsType.POINTS_OF_INTEREST]: PointsOfInterestStatisticsData;
  [StatisticsType.VEHICLE_TYPE]: VehicleTypeStatisticsData;
}
